// @flow
// Запросы для загрузки лекал папкой: модель, лекала модели, типы устройств,
// создание и замена лекала. Разбор папки — в folderUpload.js.
import gql from 'graphql-tag';
import { apolloMutate, apolloQuery } from '../core/data/apolloClient';

const CREATE_VARIANT = gql`
  mutation ($input: VariantCreate!) {
    createVariant(input: $input) { id name }
  }
`;

const UPDATE_VARIANT = gql`
  mutation ($input: VariantUpdate!) {
    updateVariant(input: $input) { id name }
  }
`;

const CREATE_DEVICE = gql`
  mutation ($input: DeviceCreate!) {
    createDevice(input: $input) { id name }
  }
`;

export function createDevice(input: { brandId: string, deviceTypeId: string, name: string }) {
  return apolloMutate(CREATE_DEVICE, { input });
}

export function listDeviceVariants(deviceId: string) {
  return apolloQuery(gql`
    query ($id: String!) {
      getDevice(id: $id) {
        id
        variants { id name }
      }
    }
  `, { id: deviceId }).then(device => device.variants || []);
}

export function listDeviceTypeOptions() {
  return apolloQuery(gql`
    query {
      listDeviceTypes { id name }
    }
  `);
}

// Новое лекало или замена файлов у существующего. При замене картинка и
// исходник меняются, только если они есть в папке, иначе остаются прежние.
export function uploadLekalo(deviceId: string, item: Object, existingId: ?string) {
  if (existingId) {
    const input: Object = { id: existingId, cut: item.cut };
    if (item.preview) input.preview = item.preview;
    if (item.source) input.source = item.source;
    return apolloMutate(UPDATE_VARIANT, { input });
  }
  return apolloMutate(CREATE_VARIANT, {
    input: {
      deviceId,
      name: item.name,
      cut: item.cut,
      preview: item.preview,
      source: item.source,
      isEnabled: true,
    },
  });
}
